import PropTypes from 'prop-types';
import Modal from 'src/components/ui/Modal';
import Button from 'src/components/ui/Button';
import Link from 'src/components/ui/Link';

// PropTypes for the component
CookieConsentDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAccept: PropTypes.func
};

// Main component
export default function CookieConsentDialog({ open, onClose, onAccept }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={<h2 className="text-base font-medium text-content-default">Cookie Consent</h2>}
      hideCloseButton={true}
      disableBackdropClick={true}
      className="max-w-md mx-4 p-6"
    >
      <p className="text-content-default text-sm">
        We use cookies and local storage to improve your user experience, track performance, and optimise onboarding. By
        clicking "Agree", you consent to our use of these technologies. For more information, please read our{' '}
        <Link href="https://complimind.co.uk/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
        .
      </p>
      <div className="mt-5 flex justify-end">
        <Button variant="primary" onClick={onAccept}>
          Agree
        </Button>
      </div>
    </Modal>
  );
}
